import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-icon',
  imports: [],
  templateUrl: './calendar-icon.html',
  styleUrl: './calendar-icon.css'
})
export class CalendarIcon {

}
